import React from 'react';
import queryString from 'query-string';

import FA from './FA';
import history from 'shared_history';

const searchQueryToObject = (search) => queryString.parse(search);
const sortInverse = (sortOrder) => (sortOrder === 'desc' ? 'asc' : 'desc');
const sortIcon = (sort, sortName) => {
  if (!sortName) {
    return null;
  }

  if (sort.column === sortName) {
    return sort.order === 'desc' ? <FA name='sort-up' preNbsp /> : <FA name='sort-down' preNbsp />;
  }

  return <FA name='sort' preNbsp />;
};

/**
 *  Utility class for sorting a dataset in which the URL is the single source of truth for the sort criteria.
 * */
class UriSorting {
  constructor(location) {
    this.location = location;
    this.history = history;
  }

  /**
   * Gets the current sort column and order as it is represented in the URL
   *
   * @param {Object} def The default sort to return if none exists
   * @return {Object} The current sort criteria.
   */
  getSort(def = {}) {
    const { search } = this.location;

    try {
      const result = JSON.parse(searchQueryToObject(search).sort);

      return Object.getOwnPropertyNames(result).length !== 0 ? result : def;
    } catch (e) {
      return def;
    }
  }

  /**
   * Provides the sort as a string
   *
   * @return {String} The current sort criteria represented as a string
   */
  getSortAsString() {
    const sort = this.getSort();
    const sortPresent = Object.getOwnPropertyNames(sort).length !== 0;

    if (
      !(
        sortPresent
        && Object.prototype.hasOwnProperty.call(sort, 'column')
        && Object.prototype.hasOwnProperty.call(sort, 'order')
      )) {
      return '';
    }

    return `${sort.column} ${sort.order}`;
  }

  /**
   * Returns a URI with the `sort` parameter in the URL set to a new sort column and direction, while preserving all
   * other parameters
   *
   * @param {Object} newSort The new sort
   */
  sortLink(newSort) {
    const { search } = this.location;
    const sortPresent = Object.getOwnPropertyNames(newSort).length !== 0;

    // noinspection JSUnusedLocalSymbols
    const { sort, ...query } = searchQueryToObject(search);

    if (sortPresent) {
      query.sort = JSON.stringify(newSort);
    }

    return `${this.location.pathname}?${queryString.stringify(query)}`;
  }
}

export {
  UriSorting as default,
  sortIcon,
  sortInverse
};
